import { APIPath } from '../constants/api';
import { CRUDService } from './crud';
import { BaseService } from './base';

class BatchOrders extends CRUDService {
  constructor() {
    super(APIPath.batchOrder);
  }

  pickList = reqData => BaseService.post(APIPath.batchOrderPick, reqData);

  fulfill = id => BaseService.post(`${APIPath.batchOrder}/${id}/fulfill`);
}

const BatchOrdersService = new BatchOrders();
Object.freeze(BatchOrdersService);
export default BatchOrdersService;
